import type { ElementSettings } from '../types';
import type { ActiveDataBinding } from '../../runtime/dataServices/types';
import type { ContainCoverFit } from '../image/contracts';

type ImageGalleryBinding = ActiveDataBinding;

export interface ImageGallerySettings extends ElementSettings {
    binding: ImageGalleryBinding | null;
    imagesPerPage: 2 | 4;
    fit: ContainCoverFit;
}

export function createDefaultImageGallerySettings(): ImageGallerySettings {
    return {
        binding: null,
        imagesPerPage: 2,
        fit: 'cover',
    };
}
